// Heap Analytics initialization script
// Loads the Heap SDK with the configured app ID from environment variables.

const HEAP_APP_ID = import.meta.env.VITE_HEAP_ANALYTICS_ID;

window.heap = window.heap || [];
window.heap.load = function (e, t) {
  window.heap.appid = e;
  window.heap.config = t || {};

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js";

  const [firstScript] = document.getElementsByTagName("script");
  firstScript.parentNode.insertBefore(script, firstScript);

  const methods = [
    "addEventProperties",
    "addUserProperties",
    "clearEventProperties",
    "identify",
    "resetIdentity",
    "removeEventProperty",
    "setEventProperties",
    "track",
    "unsetEventProperty"
  ];
  for (let i = 0; i < methods.length; i++) {
    window.heap[methods[i]] = (function (method) {
      return function (...args) {
        window.heap.push([method].concat(args));
      };
    })(methods[i]);
  }
};

if (HEAP_APP_ID) {
  window.heap.load(HEAP_APP_ID);
}
